import { Filters } from "../types/games";
import { IEjectionReport } from "../../../../types/api";

const initFilters = (reports: IEjectionReport[]): Filters => {
    return {
        dateStart: undefined,
        dateEnd: undefined,
        umpire: {
            options: Array.from(new Set(reports.flatMap(r => r.userId))).sort(),
            filter: undefined,
        },
    };
};

export default initFilters;
